import api from "@/api";
export default class Masterlist {
  constructor(_default) {
    if (_default !== undefined) {
      this._default = _default;
      for (let prop in _default) {
        this[prop] = _default[prop];
      }
    }
  }

  static async fetch(m_id) {
    const res = await api.get(`/api/v1/repair/masterlist/`, { id: m_id });
    if (res) return res.data.data[0];
    return null;
  }

  static async list(params) {
    const res = await api.get(`/api/v1/repair/masterlist/`, params);
    if (res) return res.data;
    return null;
  }

  static async store(payload) {
    const res = await api.post(`/api/v1/repair/create/masterlist/`, payload);
    if (res) return res.data.data;
    return null;
  }

  static async update(payload) {
    const res = await api.put(
      `/api/v1/repair/update/masterlist/${payload.id}/`,
      payload
    );
    if (res) return res.data.data;
    return null;
  }

  static async searchUld(params) {
    const res = await api.get(`/api/v1/repair/search_uld/masterlist/`, params);
    if (res) return res.data.data;
    return [];
  }

  static async getULDList(params) {
    const res = await api.get(
      `/api/v1/repair/masterlist/ulds/?id=${params.masterlist_id}`,
      params
    );
    if (res) return res.data;
    return {};
  }

  // static descriptions() {
  //   return [
  //     { value: "A", text: "AKE/LD3-Alu Container" },
  //     { value: "B", text: "AKE/LD3-LW Container" },
  //     { value: "C", text: "AKH/LD45-Alu Container" },
  //     { value: "D", text: "AKN/LD3-Alu Container" },
  //     { value: "E", text: "ALF/LD6-Alu Container" },
  //     { value: "F", text: "ALF/LD6-LW Container" },
  //     { value: "G", text: "AMF/LD36-Alu Container" },
  //     { value: "H", text: "AMP/LD39-Alu Container" },
  //     { value: "I", text: "AVA/LD3-Alu Container" },
  //     { value: "J", text: "FSK/LD3-Alu container" },
  //     { value: "K", text: "Horse Stall-ECS" },
  //     { value: "L", text: 'PAG Pallet 88"x125"' },
  //     { value: "M", text: 'PAJ Pallet 88"x125"' },
  //     { value: "N", text: 'PGE Pallet 96"x20ft.' },
  //     { value: "O", text: 'PGF Pallet 96"x20ft.' },
  //     { value: "P", text: 'PKC Pallet 55.4"X56.4"' },
  //     { value: "Q", text: 'PLA Pallet 60.4"x125"' },
  //     { value: "R", text: 'PMC Pallet 96"x125"' },
  //     { value: "S", text: 'PRA Pallet 96"x196" 16 ft.' },
  //     { value: "T", text: 'PYB Pallet 55"x96"' },
  //     { value: "U", text: 'PZA Pallet 96"x16ft.' },
  //     { value: "V", text: "RKE/LD3-Alu Container" },
  //     { value: "W", text: "XKF/LD3-Alu Container" },
  //     { value: "X", text: "XKN/LD3-Alu Container" },
  //     { value: "Y", text: "IGR042-Full Size Waste Cart" },
  //     { value: "Z", text: "IGR043-Half Size Waste Cart" },
  //     { value: "AA", text: "IGR711-Atlas Trolley FS Hybrite" },
  //     { value: "AB", text: "IGR712-Atlas Trolley HS Hybrite" },
  //     { value: "AC", text: "IGR713-Waste Trolley FS Hybrite" },
  //     { value: "AD", text: "IGR735-Full Size Meal Cart" },
  //     { value: "AE", text: "IGR736-Half Size Meal Cart" }
  //   ];
  // }

  static descriptions() {
    return [
      { value: "AKE/LD3-Alu Container", text: "AKE/LD3-Alu Container" },
      { value: "AKE/LD3-LW Container", text: "AKE/LD3-LW Container" },
      { value: "AKH/LD45-Alu Container", text: "AKH/LD45-Alu Container" },
      { value: "AKN/LD3-Alu Container", text: "AKN/LD3-Alu Container" },
      { value: "ALF/LD6-Alu Container", text: "ALF/LD6-Alu Container" },
      { value: "ALF/LD6-LW Container", text: "ALF/LD6-LW Container" },
      { value: "AMF/LD36-Alu Container", text: "AMF/LD36-Alu Container" },
      { value: "AMP/LD39-Alu Container", text: "AMP/LD39-Alu Container" },
      { value: "AVA/LD3-Alu Container", text: "AVA/LD3-Alu Container" },
      { value: "FSK/LD3-Alu container", text: "FSK/LD3-Alu container" },
      { value: "Horse Stall-ECS", text: "Horse Stall-ECS" },
      { value: 'PAG Pallet 88"x125"', text: 'PAG Pallet 88"x125"' },
      { value: 'PAJ Pallet 88"x125"', text: 'PAJ Pallet 88"x125"' },
      { value: 'PGE Pallet 96"x20ft.', text: 'PGE Pallet 96"x20ft.' },
      { value: 'PGF Pallet 96"x20ft.', text: 'PGF Pallet 96"x20ft.' },
      { value: 'PKC Pallet 55.4"X56.4"', text: 'PKC Pallet 55.4"X56.4"' },
      { value: 'PLA Pallet 60.4"x125"', text: 'PLA Pallet 60.4"x125"' },
      { value: 'PMC Pallet 96"x125"', text: 'PMC Pallet 96"x125"' },
      {
        value: 'PRA Pallet 96"x196" 16 ft.',
        text: 'PRA Pallet 96"x196" 16 ft.'
      },
      { value: 'PYB Pallet 55"x96"', text: 'PYB Pallet 55"x96"' },
      { value: 'PZA Pallet 96"x16ft.', text: 'PZA Pallet 96"x16ft.' },
      { value: "RKE/LD3-Alu Container", text: "RKE/LD3-Alu Container" },
      { value: "XKF/LD3-Alu Container", text: "XKF/LD3-Alu Container" },
      { value: "XKN/LD3-Alu Container", text: "XKN/LD3-Alu Container" },
      {
        value: "IGR042-Full Size Waste Cart",
        text: "IGR042-Full Size Waste Cart"
      },
      {
        value: "IGR043-Half Size Waste Cart",
        text: "IGR043-Half Size Waste Cart"
      },
      {
        value: "IGR711-Atlas Trolley FS Hybrite",
        text: "IGR711-Atlas Trolley FS Hybrite"
      },
      {
        value: "IGR712-Atlas Trolley HS Hybrite",
        text: "IGR712-Atlas Trolley HS Hybrite"
      },
      {
        value: "IGR713-Waste Trolley FS Hybrite",
        text: "IGR713-Waste Trolley FS Hybrite"
      },
      {
        value: "IGR735-Full Size Meal Cart",
        text: "IGR735-Full Size Meal Cart"
      },
      {
        value: "IGR736-Half Size Meal Cart",
        text: "IGR736-Half Size Meal Cart"
      },
      {
        value: "Horse Stall",
        text: "Horse Stall"
      },
      {
        value: "AAP/LD9-Alu Container",
        text: "AAP/LD9-Alu Container"
      },
      {
        value: 'PGA Pallet 96"x20ft.',
        text: 'PGA Pallet 96"x20ft.'
      },
      {
        value: 'PSA Pallet 96"x196" 16 ft.',
        text: 'PSA Pallet 96"x196" 16 ft.'
      },
      {
        value: 'PRF Pallet 96"x196" 16 ft.',
        text: 'PRF Pallet 96"x196" 16 ft.'
      },
      {
        value: 'AVA/LD3-LW Container',
        text: 'AVA/LD3-LW Container'
      }
    ];
  }
}
